export const dramas = [
  {
    id: "saozi-de-zhiye",
    title: "嫂子的职业",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20Chinese%20drama%20key%20art%2C%20elegant%20woman%20in%20tailored%20beige%20suit%20standing%20beside%20a%20rainy%20window%20in%20a%20warm%20apartment%2C%20deep%20navy%20shadows%20with%20soft%20amber%20lamplight%2C%20refined%20editorial%20photography%2C%20subtle%20film%20grain%2C%20minimal%20composition%2C%20no%20text%2C%20no%20lettering&width=400&height=560&seq=drama-cover-01&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20confident%20woman%20in%20a%20beige%20blazer%20standing%20in%20a%20modern%20glass%20office%20at%20dusk%2C%20city%20skyline%20glowing%20behind%20her%2C%20deep%20navy%20blue%20tones%20with%20warm%20amber%20rim%20light%2C%20premium%20streaming%20drama%20poster%20photography%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=1920&height=900&seq=drama-banner-01&orientation=landscape",
    year: 2024,
    region: "内地",
    genres: ["都市", "情感"],
    cast: ["林知夏", "周慕然", "陈少白"],
    director: "高启明",
    status: "更新至 32 集",
    totalEpisodes: 40,
    updatedEpisodes: 32,
    synopsis:
      "一场突如其来的家庭变故，让原本安静持家的沈知意不得不重新走进职场。从社区咖啡馆的临时帮工，到连锁品牌的区域负责人，她用三年时间重新定义了自己。家人的不理解、旧友的质疑、同行的竞争，都成为她成长的注脚。这是一部关于普通人如何靠专业与体面赢回人生的都市情感剧。",
    tags: ["女性成长", "职场逆袭", "家庭关系", "口碑佳作"],
    rating: 8.9,
    views: "1.28 亿",
    heat: 98,
    updatedAt: "2024-06-18",
    featured: true,
  },
  {
    id: "zhichang-miwu",
    title: "职场迷雾",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20Chinese%20workplace%20thriller%20poster%2C%20man%20in%20dark%20suit%20walking%20through%20a%20glass%20corridor%20with%20long%20shadows%2C%20cool%20steel%20blue%20tones%20with%20single%20amber%20ceiling%20light%2C%20moody%20editorial%20photography%2C%20soft%20film%20grain%2C%20minimal%20composition%2C%20no%20text%2C%20no%20lettering&width=400&height=560&seq=drama-cover-02&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20angle%20of%20empty%20corporate%20boardroom%20at%20night%2C%20blue%20haze%20outside%20floor%20to%20ceiling%20windows%2C%20one%20warm%20desk%20lamp%20glowing%2C%20atmospheric%20suspense%20drama%20still%2C%20deep%20navy%20palette%2C%20soft%20film%20grain%2C%20no%20people%2C%20no%20text&width=1920&height=900&seq=drama-banner-02&orientation=landscape",
    year: 2023,
    region: "内地",
    genres: ["职场", "悬疑"],
    cast: ["白敬安", "苏黎", "何晏"],
    director: "沈望",
    status: "全 36 集",
    totalEpisodes: 36,
    updatedEpisodes: 36,
    synopsis:
      "一封匿名举报信，让上市集团的年度审计陷入停摆。新来的合规顾问白天整理报表，夜里追查一笔笔异常流水，却发现公司里每个人都藏着一段不愿被提起的往事。真相越近，代价越大。",
    tags: ["商战", "悬疑推理", "双男主", "高分剧"],
    rating: 9.1,
    views: "9860 万",
    heat: 95,
    updatedAt: "2024-05-27",
    featured: true,
  },
  {
    id: "dushi-yeguiren",
    title: "都市夜归人",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20urban%20romance%20drama%20poster%2C%20young%20woman%20with%20short%20hair%20in%20a%20light%20coat%20waiting%20at%20a%20late%20night%20bus%20stop%2C%20wet%20asphalt%20reflecting%20warm%20streetlights%2C%20teal%20and%20amber%20color%20contrast%2C%20moody%20editorial%20photography%2C%20soft%20grain%2C%20no%20text&width=400&height=560&seq=drama-cover-03&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20night%20city%20street%20after%20rain%2C%20warm%20shop%20lights%20and%20deep%20blue%20sky%2C%20lone%20figure%20walking%20with%20umbrella%2C%20bokeh%20reflections%20on%20the%20road%2C%20atmospheric%20modern%20drama%20still%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=1920&height=900&seq=drama-banner-03&orientation=landscape",
    year: 2024,
    region: "内地",
    genres: ["都市", "情感"],
    cast: ["江晚", "顾逸辰", "唐甜"],
    director: "许南舟",
    status: "更新至 24 集",
    totalEpisodes: 32,
    updatedEpisodes: 24,
    synopsis:
      "凌晨一点的便利店、末班地铁和永远亮着灯的写字楼，是这座城市最真实的切片。三个在夜里工作的年轻人，因为一台坏掉的咖啡机认识，从此彼此的生活有了交集。",
    tags: ["治愈系", "群像", "夜归人", "都市生活"],
    rating: 8.6,
    views: "7420 万",
    heat: 90,
    updatedAt: "2024-06-20",
    featured: false,
  },
  {
    id: "tade-dier-rensheng",
    title: "她的第二人生",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20female%20growth%20drama%20poster%2C%20woman%20in%20cream%20knitwear%20standing%20in%20a%20small%20bookshop%20surrounded%20by%20warm%20shelves%2C%20soft%20window%20daylight%20with%20dust%20motes%2C%20muted%20teal%20and%20sand%20palette%2C%20refined%20editorial%20photography%2C%20subtle%20grain%2C%20no%20text&width=400&height=560&seq=drama-cover-04&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20sunlit%20bookstore%20interior%20with%20tall%20wooden%20shelves%2C%20woman%20reading%20by%20the%20window%2C%20warm%20golden%20afternoon%20light%20and%20soft%20dust%20in%20the%20air%2C%20gentle%20teal%20accents%2C%20premium%20drama%20still%2C%20no%20text%2C%20no%20lettering&width=1920&height=900&seq=drama-banner-04&orientation=landscape",
    year: 2023,
    region: "内地",
    genres: ["情感", "都市", "励志"],
    cast: ["许清和", "陆昀", "宋母"],
    director: "叶青",
    status: "全 40 集",
    totalEpisodes: 40,
    updatedEpisodes: 40,
    synopsis:
      "四十岁生日那天，她把经营了十五年的店盘了出去。有人替她惋惜，有人觉得她疯了，只有她自己知道，这是她第一次为自己做决定。一间旧书店、一群陌生人，让她重新学会期待明天。",
    tags: ["女性成长", "温暖治愈", "中年重启", "口碑佳作"],
    rating: 8.8,
    views: "8310 万",
    heat: 88,
    updatedAt: "2024-04-12",
    featured: false,
  },
  {
    id: "niguang-erxing",
    title: "逆光而行",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20inspirational%20drama%20poster%2C%20young%20man%20in%20white%20shirt%20climbing%20outdoor%20stadium%20stairs%20at%20golden%20sunset%2C%20strong%20backlight%20and%20long%20shadows%2C%20deep%20navy%20sky%20gradient%2C%20editorial%20sports%20photography%2C%20soft%20film%20grain%2C%20no%20text&width=400&height=560&seq=drama-cover-05&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20running%20track%20at%20golden%20hour%2C%20backlit%20athlete%20silhouette%20mid%20stride%2C%20dust%20glowing%20in%20warm%20sunlight%2C%20deep%20navy%20shadows%2C%20premium%20sports%20drama%20still%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=1920&height=900&seq=drama-banner-05&orientation=landscape",
    year: 2022,
    region: "内地",
    genres: ["职场", "励志"],
    cast: ["程砚", "叶南", "许朗"],
    director: "周牧",
    status: "全 38 集",
    totalEpisodes: 38,
    updatedEpisodes: 38,
    synopsis:
      "被伤病终结职业生涯的短跑运动员，转身成了写字楼里最不起眼的行政助理。当公司组建业余跑团，他第一次发现，有些能力不会因为离开赛场而消失。",
    tags: ["热血", "成长", "体育", "正能量"],
    rating: 8.4,
    views: "6120 万",
    heat: 83,
    updatedAt: "2024-03-08",
    featured: false,
  },
  {
    id: "jiade-fangxiang",
    title: "家的方向",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20family%20drama%20poster%2C%20warm%20dining%20table%20scene%20with%20steaming%20dishes%20and%20empty%20wooden%20chairs%2C%20soft%20amber%20hanging%20lamp%2C%20deep%20navy%20evening%20window%20behind%2C%20nostalgic%20editorial%20photography%2C%20soft%20grain%2C%20no%20text&width=400&height=560&seq=drama-cover-06&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20old%20neighborhood%20alley%20at%20dusk%2C%20warm%20windows%20glowing%20in%20concrete%20buildings%2C%20laundry%20lines%20and%20bicycles%2C%20deep%20blue%20sky%20above%20warm%20amber%20streetlight%2C%20nostalgic%20drama%20still%2C%20soft%20grain%2C%20no%20text&width=1920&height=900&seq=drama-banner-06&orientation=landscape",
    year: 2024,
    region: "内地",
    genres: ["家庭", "情感"],
    cast: ["温岚", "何国庆", "何小满"],
    director: "刘治平",
    status: "更新至 30 集",
    totalEpisodes: 42,
    updatedEpisodes: 30,
    synopsis:
      "老房子要拆了，三个子女为了补偿款各怀心思，只有母亲每天照旧在阳台上浇花。一顿饭、一张旧照片、一句没说出口的道歉，把这个快要散掉的家重新拢在一起。",
    tags: ["家庭群像", "现实题材", "亲情", "催泪"],
    rating: 8.7,
    views: "7050 万",
    heat: 86,
    updatedAt: "2024-06-15",
    featured: false,
  },
  {
    id: "chenmo-de-zhengci",
    title: "沉默的证词",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20mystery%20drama%20poster%2C%20detective%20in%20dark%20trench%20coat%20standing%20in%20a%20dim%20parking%20garage%2C%20single%20cold%20fluorescent%20light%2C%20wet%20concrete%20floor%20reflections%2C%20deep%20navy%20and%20steel%20grey%20palette%2C%20gritty%20editorial%20photography%2C%20no%20text&width=400&height=560&seq=drama-cover-07&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20empty%20police%20interrogation%20room%2C%20single%20hanging%20lamp%20over%20a%20metal%20table%2C%20deep%20blue%20shadows%20and%20cold%20grey%20walls%2C%20atmospheric%20crime%20drama%20still%2C%20soft%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=1920&height=900&seq=drama-banner-07&orientation=landscape",
    year: 2023,
    region: "香港",
    genres: ["悬疑", "都市"],
    cast: ["方启铭", "罗嘉欣", "杜文"],
    director: "陈立行",
    status: "全 28 集",
    totalEpisodes: 28,
    updatedEpisodes: 28,
    synopsis:
      "一名沉默寡言的听力障碍证人，是唯一见过案发经过的人。为了让她的证词被法庭采信，年轻检察官必须在七天之内，找到所有人都忽略的那个细节。",
    tags: ["悬疑推理", "律政", "港剧", "高分剧"],
    rating: 9.0,
    views: "5640 万",
    heat: 87,
    updatedAt: "2024-02-19",
    featured: false,
  },
  {
    id: "chunfeng-shili",
    title: "春风十里",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20period%20romance%20drama%20poster%2C%20young%20woman%20in%20light%20blue%20vintage%20dress%20riding%20a%20bicycle%20along%20a%20tree%20lined%20country%20road%2C%20spring%20blossoms%20falling%2C%20warm%20sunlight%20through%20leaves%2C%20soft%20nostalgic%20film%20look%2C%20no%20text&width=400&height=560&seq=drama-cover-08&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20spring%20countryside%20road%20lined%20with%20blooming%20trees%2C%20warm%20golden%20sunlight%20through%20leaves%2C%20vintage%20bicycle%20leaning%20by%20a%20stone%20wall%2C%20nostalgic%20period%20drama%20still%2C%20soft%20film%20grain%2C%20no%20text&width=1920&height=900&seq=drama-banner-08&orientation=landscape",
    year: 2021,
    region: "内地",
    genres: ["情感", "年代"],
    cast: ["沈书", "宋时雨", "程建国"],
    director: "邓怀远",
    status: "全 45 集",
    totalEpisodes: 45,
    updatedEpisodes: 45,
    synopsis:
      "上世纪八十年代的小城，两个年轻人在图书馆相遇，一封没有寄出的信改变了他们此后二十年的轨迹。时代向前，情意留在原地，等一个迟到的回答。",
    tags: ["年代感", "纯爱", "怀旧", "经典重看"],
    rating: 8.2,
    views: "4380 万",
    heat: 74,
    updatedAt: "2023-11-30",
    featured: false,
  },
  {
    id: "fanhua-beihou",
    title: "繁华背后",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20business%20drama%20poster%2C%20two%20professionals%20in%20dark%20tailored%20suits%20shaking%20hands%20in%20a%20luxury%20hotel%20lobby%2C%20warm%20brass%20details%20and%20deep%20navy%20marble%2C%20dramatic%20side%20lighting%2C%20premium%20editorial%20photography%2C%20soft%20grain%2C%20no%20text&width=400&height=560&seq=drama-cover-09&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20night%20view%20of%20a%20luxury%20hotel%20lobby%20with%20brass%20chandeliers%20and%20deep%20navy%20marble%20floors%2C%20empty%20and%20quiet%2C%20warm%20amber%20pool%20of%20light%2C%20elegant%20business%20drama%20still%2C%20soft%20grain%2C%20no%20text&width=1920&height=900&seq=drama-banner-09&orientation=landscape",
    year: 2022,
    region: "内地",
    genres: ["职场", "都市"],
    cast: ["罗晋川", "安静", "陆承宇"],
    director: "章明宇",
    status: "全 34 集",
    totalEpisodes: 34,
    updatedEpisodes: 34,
    synopsis:
      "一场并购案让两个立场相反的人坐在了同一张谈判桌前。白天他们针锋相对，夜里却在同一间便利店买同一款关东煮。成年人的心动，总在输赢之外。",
    tags: ["商战", "势均力敌", "都市爱情", "职场"],
    rating: 8.5,
    views: "6890 万",
    heat: 81,
    updatedAt: "2024-01-22",
    featured: false,
  },
  {
    id: "wenroude-jianchi",
    title: "温柔的坚持",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20healing%20family%20drama%20poster%2C%20mother%20and%20teenage%20daughter%20cooking%20together%20in%20a%20bright%20small%20kitchen%2C%20soft%20morning%20light%2C%20warm%20cream%20and%20sage%20tones%2C%20tender%20editorial%20photography%2C%20soft%20film%20grain%2C%20no%20text&width=400&height=560&seq=drama-cover-10&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20bright%20kitchen%20morning%20scene%20with%20fresh%20herbs%20and%20ceramic%20bowls%2C%20sheer%20curtain%20glowing%20with%20sunlight%2C%20warm%20cream%20and%20sage%20palette%2C%20gentle%20family%20drama%20still%2C%20soft%20film%20grain%2C%20no%20text&width=1920&height=900&seq=drama-banner-10&orientation=landscape",
    year: 2024,
    region: "内地",
    genres: ["情感", "家庭"],
    cast: ["苏念", "顾城", "多多"],
    director: "林蔚",
    status: "更新至 18 集",
    totalEpisodes: 30,
    updatedEpisodes: 18,
    synopsis:
      "单亲妈妈经营着一家小小的家常菜馆，女儿却在青春期把自己关进了房间。一道外婆留下的糖醋排骨，成了母女之间唯一还通着的信号。",
    tags: ["治愈", "母女关系", "美食", "生活流"],
    rating: 8.3,
    views: "3920 万",
    heat: 78,
    updatedAt: "2024-06-21",
    featured: false,
  },
  {
    id: "tanpan-zhuanjia",
    title: "谈判专家",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20Hong%20Kong%20crime%20drama%20poster%2C%20negotiator%20in%20dark%20suit%20holding%20a%20phone%20on%20a%20rooftop%20at%20night%2C%20city%20lights%20blurred%20behind%2C%20cool%20navy%20palette%20with%20single%20red%20signal%20light%2C%20gritty%20editorial%20photography%2C%20no%20text&width=400&height=560&seq=drama-cover-11&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20Hong%20Kong%20harbour%20skyline%20at%20night%20from%20a%20rooftop%2C%20deep%20navy%20sky%20and%20scattered%20warm%20city%20lights%2C%20rain%20slick%20concrete%20foreground%2C%20tense%20crime%20drama%20still%2C%20soft%20film%20grain%2C%20no%20text&width=1920&height=900&seq=drama-banner-11&orientation=landscape",
    year: 2023,
    region: "香港",
    genres: ["职场", "悬疑"],
    cast: ["高天赐", "何静怡", "麦志豪"],
    director: "黄伟业",
    status: "全 24 集",
    totalEpisodes: 24,
    updatedEpisodes: 24,
    synopsis:
      "他是警队里最会说服人的那一个，却说服不了自己的父亲。一宗持续十二小时的挟持案，把他和二十年前的一桩旧案重新连在了一起。",
    tags: ["港剧", "谈判", "警匪", "高能反转"],
    rating: 8.9,
    views: "5230 万",
    heat: 85,
    updatedAt: "2024-03-27",
    featured: false,
  },
  {
    id: "xiaocheng-gushi-duo",
    title: "小城故事多",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20small%20town%20slice%20of%20life%20drama%20poster%2C%20young%20woman%20running%20a%20small%20noodle%20shop%20with%20steam%20rising%2C%20warm%20evening%20lanterns%20and%20teal%20dusk%20sky%2C%20friendly%20neighbors%20in%20soft%20focus%2C%20warm%20editorial%20photography%2C%20no%20text&width=400&height=560&seq=drama-cover-12&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20small%20town%20market%20street%20at%20blue%20hour%2C%20warm%20lantern%20glow%20from%20food%20stalls%2C%20steam%20rising%2C%20deep%20teal%20sky%2C%20cozy%20slice%20of%20life%20drama%20still%2C%20soft%20film%20grain%2C%20no%20text&width=1920&height=900&seq=drama-banner-12&orientation=landscape",
    year: 2022,
    region: "内地",
    genres: ["都市", "家庭"],
    cast: ["赵小满", "李承泽", "王婶"],
    director: "钱多多",
    status: "全 36 集",
    totalEpisodes: 36,
    updatedEpisodes: 36,
    synopsis:
      "大城市待了七年的她，带着一身疲惫回到老家，接手了母亲留下的面馆。街坊邻里的鸡毛蒜皮，反而成了治愈她的良药。",
    tags: ["烟火气", "返乡", "群像", "轻松治愈"],
    rating: 8.0,
    views: "3460 万",
    heat: 70,
    updatedAt: "2023-09-14",
    featured: false,
  },
  {
    id: "shijian-dou-zhidao",
    title: "时间都知道",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20romantic%20fantasy%20drama%20poster%2C%20woman%20standing%20in%20a%20vintage%20clock%20tower%20room%20surrounded%20by%20floating%20dust%20and%20gears%2C%20warm%20amber%20light%20through%20arched%20windows%2C%20dreamy%20soft%20focus%20editorial%20photography%2C%20no%20text&width=400&height=560&seq=drama-cover-13&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20vintage%20clock%20tower%20interior%20with%20huge%20brass%20gears%2C%20warm%20amber%20sunbeams%20through%20arched%20windows%2C%20dust%20particles%20floating%2C%20dreamy%20romantic%20fantasy%20drama%20still%2C%20no%20text&width=1920&height=900&seq=drama-banner-13&orientation=landscape",
    year: 2021,
    region: "内地",
    genres: ["情感", "奇幻"],
    cast: ["时简", "莫亦", "程可"],
    director: "苏亦然",
    status: "全 40 集",
    totalEpisodes: 40,
    updatedEpisodes: 40,
    synopsis:
      "婚礼前夜，她收到一只停在十年前的旧手表。每一次指针倒转，她都会回到同一个夏天，重新遇见那个还没来得及道别的人。",
    tags: ["时空", "遗憾", "纯爱", "虐心"],
    rating: 8.6,
    views: "5970 万",
    heat: 79,
    updatedAt: "2023-12-05",
    featured: false,
  },
  {
    id: "yixian-shengji",
    title: "一线生机",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20medical%20thriller%20drama%20poster%2C%20surgeon%20in%20dark%20green%20scrubs%20standing%20in%20a%20dim%20hospital%20corridor%2C%20cold%20teal%20lighting%20with%20one%20warm%20exit%20sign%2C%20tense%20editorial%20photography%2C%20soft%20film%20grain%2C%20no%20text&width=400&height=560&seq=drama-cover-14&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20empty%20hospital%20corridor%20at%20night%2C%20cold%20teal%20fluorescent%20light%20and%20one%20warm%20lit%20doorway%2C%20polished%20floor%20reflections%2C%20tense%20medical%20drama%20still%2C%20soft%20film%20grain%2C%20no%20text&width=1920&height=900&seq=drama-banner-14&orientation=landscape",
    year: 2024,
    region: "内地",
    genres: ["悬疑", "职场"],
    cast: ["沈知白", "顾清", "许医生"],
    director: "陆一鸣",
    status: "更新至 16 集",
    totalEpisodes: 26,
    updatedEpisodes: 16,
    synopsis:
      "一台本不该失败的手术，让年轻外科医生被停职调查。为了证明清白，他开始追查病历系统里那条被删除的记录，却发现整层楼的人都在替他隐瞒。",
    tags: ["医疗", "悬疑", "强情节", "追剧必看"],
    rating: 8.8,
    views: "4720 万",
    heat: 84,
    updatedAt: "2024-06-19",
    featured: false,
  },
  {
    id: "tade-chuntian",
    title: "她的春天",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20inspirational%20female%20drama%20poster%2C%20woman%20in%20simple%20white%20shirt%20standing%20in%20a%20greenhouse%20full%20of%20young%20seedlings%2C%20soft%20diffused%20daylight%2C%20fresh%20sage%20and%20cream%20palette%2C%20hopeful%20editorial%20photography%2C%20no%20text&width=400&height=560&seq=drama-cover-15&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20sunlit%20greenhouse%20with%20rows%20of%20young%20plants%2C%20soft%20morning%20haze%2C%20sage%20green%20and%20warm%20cream%20palette%2C%20hopeful%20inspirational%20drama%20still%2C%20soft%20film%20grain%2C%20no%20text&width=1920&height=900&seq=drama-banner-15&orientation=landscape",
    year: 2023,
    region: "内地",
    genres: ["情感", "励志"],
    cast: ["林小满", "周舟", "老陈"],
    director: "温之远",
    status: "全 38 集",
    totalEpisodes: 38,
    updatedEpisodes: 38,
    synopsis:
      "从流水线女工到农业技术员，她把别人眼里不可能的事，一件一件做成了。泥土、汗水和一次次失败，见证了一个普通女性最踏实的生长。",
    tags: ["励志", "乡村", "女性力量", "真实改编"],
    rating: 8.1,
    views: "3180 万",
    heat: 68,
    updatedAt: "2023-10-20",
    featured: false,
  },
  {
    id: "yujian-ni-zhihou",
    title: "遇见你之后",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20Korean%20romance%20drama%20poster%2C%20couple%20under%20a%20shared%20umbrella%20on%20a%20rainy%20Seoul%20street%2C%20warm%20shop%20signs%20reflected%20in%20puddles%2C%20soft%20teal%20and%20amber%20tones%2C%20delicate%20editorial%20photography%2C%20no%20text&width=400&height=560&seq=drama-cover-16&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20rainy%20Seoul%20alley%20at%20dusk%2C%20warm%20cafe%20signs%20reflected%20in%20wet%20cobblestones%2C%20soft%20teal%20and%20amber%20tones%2C%20romantic%20Korean%20drama%20still%2C%20soft%20film%20grain%2C%20no%20text&width=1920&height=900&seq=drama-banner-16&orientation=landscape",
    year: 2022,
    region: "韩国",
    genres: ["都市", "情感"],
    cast: ["金智媛", "李在勋", "朴秀贤"],
    director: "郑敏浩",
    status: "全 30 集",
    totalEpisodes: 30,
    updatedEpisodes: 30,
    synopsis:
      "她在异国他乡丢了钱包，他恰好路过。一次借伞，换来两个人在陌生城市里互相取暖的一个冬天。",
    tags: ["韩剧", "异国", "慢热", "冬日氛围"],
    rating: 8.4,
    views: "4520 万",
    heat: 76,
    updatedAt: "2023-08-16",
    featured: false,
  },
  {
    id: "shenxiang-denghuo",
    title: "深巷灯火",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20nostalgic%20family%20saga%20poster%2C%20old%20lane%20with%20red%20lanterns%20and%20wooden%20doors%2C%20elderly%20woman%20sitting%20at%20a%20sewing%20machine%20by%20warm%20window%20light%2C%20muted%20amber%20and%20deep%20teal%20palette%2C%20no%20text&width=400&height=560&seq=drama-cover-17&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20old%20Chinese%20lane%20at%20night%20with%20warm%20lanterns%20and%20worn%20brick%20walls%2C%20soft%20rain%20falling%2C%20deep%20teal%20shadows%20and%20amber%20glow%2C%20nostalgic%20family%20saga%20still%2C%20soft%20film%20grain%2C%20no%20text&width=1920&height=900&seq=drama-banner-17&orientation=landscape",
    year: 2021,
    region: "内地",
    genres: ["家庭", "年代"],
    cast: ["陈国栋", "吴素芬", "陈立冬"],
    director: "孟长河",
    status: "全 44 集",
    totalEpisodes: 44,
    updatedEpisodes: 44,
    synopsis:
      "巷子最深处的裁缝铺，开了整整四十年。老裁缝记得每一个客人的尺寸，却始终没能缝合自己和大儿子之间那道口子。",
    tags: ["年代", "匠人", "亲情", "经典"],
    rating: 8.7,
    views: "4090 万",
    heat: 72,
    updatedAt: "2023-07-11",
    featured: false,
  },
  {
    id: "mingtian-nihao",
    title: "明天你好",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20youth%20workplace%20drama%20poster%2C%20three%20young%20colleagues%20laughing%20on%20an%20office%20rooftop%20at%20sunset%2C%20warm%20orange%20sky%20and%20deep%20navy%20city%20silhouette%2C%20energetic%20editorial%20photography%2C%20soft%20film%20grain%2C%20no%20text&width=400&height=560&seq=drama-cover-18&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20city%20rooftop%20at%20sunset%20with%20warm%20orange%20sky%20and%20deep%20navy%20skyline%2C%20string%20lights%20and%20plastic%20chairs%2C%20youthful%20workplace%20drama%20still%2C%20soft%20film%20grain%2C%20no%20text&width=1920&height=900&seq=drama-banner-18&orientation=landscape",
    year: 2024,
    region: "内地",
    genres: ["都市", "励志"],
    cast: ["唐星", "韩野", "谢苗"],
    director: "陶然",
    status: "更新至 20 集",
    totalEpisodes: 32,
    updatedEpisodes: 20,
    synopsis:
      "四个刚毕业的年轻人合租在一间顶楼小屋，白天在各自的工位上挣扎，晚上在天台上交换今天的委屈和明天的计划。",
    tags: ["青春", "合租", "职场新人", "轻松"],
    rating: 8.2,
    views: "3650 万",
    heat: 75,
    updatedAt: "2024-06-17",
    featured: false,
  },
  {
    id: "wusheng-gaobai",
    title: "无声告白",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20Japanese%20mystery%20drama%20poster%2C%20woman%20holding%20an%20old%20letter%20in%20a%20quiet%20tatami%20room%2C%20soft%20window%20light%20and%20long%20shadows%2C%20muted%20indigo%20and%20warm%20paper%20tones%2C%20restrained%20editorial%20photography%2C%20no%20text&width=400&height=560&seq=drama-cover-19&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20quiet%20Japanese%20house%20interior%20with%20tatami%20mats%20and%20sliding%20paper%20doors%2C%20soft%20afternoon%20light%20casting%20long%20shadows%2C%20muted%20indigo%20and%20warm%20paper%20tones%2C%20no%20text&width=1920&height=900&seq=drama-banner-19&orientation=landscape",
    year: 2023,
    region: "日本",
    genres: ["悬疑", "情感"],
    cast: ["佐藤绫", "松本凉", "小林凛"],
    director: "山田启",
    status: "全 28 集",
    totalEpisodes: 28,
    updatedEpisodes: 28,
    synopsis:
      "整理母亲遗物时，她发现了一箱从未寄出的信。收信人住在同一条街的尽头，而她从小到大，都不知道这个人的存在。",
    tags: ["日剧", "家庭秘密", "细腻", "慢悬疑"],
    rating: 8.5,
    views: "2870 万",
    heat: 66,
    updatedAt: "2023-11-02",
    featured: false,
  },
  {
    id: "guitu-lieche",
    title: "归途列车",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20emotional%20family%20drama%20poster%2C%20young%20man%20with%20backpack%20looking%20out%20of%20a%20train%20window%20at%20blue%20hour%2C%20warm%20interior%20cabin%20light%20reflected%20on%20glass%2C%20wheat%20fields%20blurring%20past%2C%20no%20text&width=400&height=560&seq=drama-cover-20&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20night%20train%20crossing%20a%20wide%20landscape%2C%20warm%20lit%20windows%20and%20deep%20blue%20evening%20sky%2C%20soft%20mist%20over%20fields%2C%20emotional%20family%20drama%20still%2C%20no%20text&width=1920&height=900&seq=drama-banner-20&orientation=landscape",
    year: 2022,
    region: "内地",
    genres: ["家庭", "情感"],
    cast: ["周远", "许安琪", "周父"],
    director: "徐怀",
    status: "全 36 集",
    totalEpisodes: 36,
    updatedEpisodes: 36,
    synopsis:
      "十年没回家的他，在一张春运车票上犹豫了整整一夜。列车穿过三个省份，也把他和父亲之间那些没说出口的话，一节一节地拉近。",
    tags: ["亲情", "春运", "公路感", "治愈"],
    rating: 8.3,
    views: "2760 万",
    heat: 64,
    updatedAt: "2023-06-09",
    featured: false,
  },
  {
    id: "yese-wenrou",
    title: "夜色温柔",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20Taiwanese%20urban%20romance%20poster%2C%20woman%20standing%20on%20a%20balcony%20overlooking%20a%20warm%20lit%20city%20at%20night%2C%20sheer%20curtain%20blowing%2C%20deep%20teal%20sky%20and%20amber%20window%20glow%2C%20soft%20editorial%20photography%2C%20no%20text&width=400&height=560&seq=drama-cover-21&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20Taipei%20city%20balcony%20view%20at%20night%2C%20warm%20apartment%20windows%20and%20deep%20teal%20sky%2C%20soft%20bokeh%20streetlights%2C%20romantic%20urban%20drama%20still%2C%20no%20text&width=1920&height=900&seq=drama-banner-21&orientation=landscape",
    year: 2023,
    region: "台湾",
    genres: ["都市", "情感"],
    cast: ["柯以宁", "林子谦", "许安安"],
    director: "陈品蓉",
    status: "全 26 集",
    totalEpisodes: 26,
    updatedEpisodes: 26,
    synopsis:
      "两个在深夜电台里互相点歌的陌生人，隔着一条街住了三年。他们熟悉彼此的嗓音，却从没见过对方的脸。",
    tags: ["台剧", "电台", "慢热", "文艺"],
    rating: 8.0,
    views: "2140 万",
    heat: 61,
    updatedAt: "2023-05-18",
    featured: false,
  },
  {
    id: "sanshi-sui-yihou",
    title: "三十岁以后",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20modern%20women%20ensemble%20drama%20poster%2C%20three%20women%20in%20their%20thirties%20sitting%20together%20in%20a%20rooftop%20restaurant%20at%20dusk%2C%20warm%20string%20lights%2C%20deep%20navy%20sky%2C%20confident%20editorial%20photography%2C%20no%20text&width=400&height=560&seq=drama-cover-22&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20rooftop%20dining%20area%20at%20dusk%20with%20warm%20string%20lights%20and%20deep%20navy%20sky%2C%20city%20glow%20in%20the%20distance%2C%20intimate%20women%20ensemble%20drama%20still%2C%20no%20text&width=1920&height=900&seq=drama-banner-22&orientation=landscape",
    year: 2022,
    region: "内地",
    genres: ["都市", "家庭", "情感"],
    cast: ["周慧", "李蔓", "查小雅"],
    director: "华亦然",
    status: "全 34 集",
    totalEpisodes: 34,
    updatedEpisodes: 34,
    synopsis:
      "三十岁之后，她们一个失业、一个离婚、一个还在还房贷。但每次坐在天台上吃完一顿火锅，生活好像又能继续往前走一点。",
    tags: ["女性群像", "现实", "友情", "共鸣"],
    rating: 8.4,
    views: "5010 万",
    heat: 77,
    updatedAt: "2024-02-06",
    featured: false,
  },
  {
    id: "yinxing-de-ta",
    title: "隐形的她",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20psychological%20mystery%20poster%2C%20woman%20reflected%20in%20a%20cracked%20mirror%20inside%20an%20empty%20apartment%2C%20cold%20moonlight%20with%20one%20warm%20lamp%2C%20deep%20navy%20and%20cream%20palette%2C%20no%20text&width=400&height=560&seq=drama-cover-23&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20empty%20dark%20apartment%20living%20room%20lit%20by%20cold%20moonlight%20through%20sheer%20curtains%2C%20one%20warm%20table%20lamp%2C%20eerie%20calm%2C%20psychological%20mystery%20drama%20still%2C%20no%20text&width=1920&height=900&seq=drama-banner-23&orientation=landscape",
    year: 2024,
    region: "内地",
    genres: ["悬疑", "情感"],
    cast: ["颜瑜", "霍明", "罗静"],
    director: "程未",
    status: "更新至 12 集",
    totalEpisodes: 24,
    updatedEpisodes: 12,
    synopsis:
      "搬进新家后，她总觉得屋子里还有另一个人生活的痕迹。多出来的一只杯子、半夜亮起的灯，都在提醒她：这段婚姻里，有个人从未离开。",
    tags: ["心理悬疑", "婚姻", "高能", "新剧"],
    rating: 8.6,
    views: "3890 万",
    heat: 82,
    updatedAt: "2024-06-22",
    featured: false,
  },
  {
    id: "baizhou-xingguang",
    title: "白昼星光",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20workplace%20romance%20drama%20poster%2C%20woman%20in%20white%20blouse%20standing%20in%20a%20sunlit%20architecture%20studio%20with%20blueprints%2C%20warm%20natural%20light%2C%20clean%20neutral%20palette%20with%20navy%20accents%2C%20no%20text&width=400&height=560&seq=drama-cover-24&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20bright%20architecture%20studio%20with%20large%20windows%20and%20rolled%20blueprints%2C%20warm%20afternoon%20sunlight%20on%20concrete%20floors%2C%20calm%20professional%20drama%20still%2C%20no%20text&width=1920&height=900&seq=drama-banner-24&orientation=landscape",
    year: 2021,
    region: "内地",
    genres: ["职场", "情感"],
    cast: ["黎星", "沈昼", "杨帆"],
    director: "白屿",
    status: "全 40 集",
    totalEpisodes: 40,
    updatedEpisodes: 40,
    synopsis:
      "她是事务所里最年轻的主创设计师，他是甲方最难搞的项目负责人。一张改了二十七遍的图纸，成了两个人最漫长的告别与重逢。",
    tags: ["建筑", "职场爱情", "专业", "双向奔赴"],
    rating: 8.1,
    views: "3320 万",
    heat: 69,
    updatedAt: "2023-04-25",
    featured: false,
  },
];